import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSwitch,{staticClass:"mt-4 mb-2",attrs:{"hide-details":"","inset":"","label":"Utilizar Estoque Atual"},on:{"change":function($event){return _vm.aplicarStatusDoEstoque()}},model:{value:(_vm.status_switch),callback:function ($$v) {_vm.status_switch=$$v},expression:"status_switch"}})
}
var staticRenderFns = []

export { render, staticRenderFns }